import { render, staticRenderFns } from "./AgentScanButton.vue?vue&type=template&id=224284dc&scoped=true"
import script from "./AgentScanButton.vue?vue&type=script&lang=js"
export * from "./AgentScanButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224284dc",
  null
  
)

export default component.exports